import React from 'react';

interface TrialBannerProps {
    trialEndDate: string; // ISO date string
    onOpenPricingModal: () => void;
}

const TrialBanner: React.FC<TrialBannerProps> = ({ trialEndDate, onOpenPricingModal }) => {
    
    const calculateDaysLeft = () => {
        const end = new Date(trialEndDate);
        const now = new Date();
        const diffTime = end.getTime() - now.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return Math.max(0, diffDays); // Ensure it doesn't show negative days
    };

    const daysLeft = calculateDaysLeft();

    if (daysLeft === 0) {
        return null; // Or show a "trial ends today" message
    }

    return (
        <div className="bg-primary/80 backdrop-blur-sm text-white text-center p-2 text-sm font-medium z-50">
            Te quedan {daysLeft} {daysLeft === 1 ? 'día' : 'días'} de prueba.
            <button 
                onClick={onOpenPricingModal}
                className="ml-4 font-bold underline hover:text-yellow-300 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            >
                ¡Suscríbete ahora!
            </button>
        </div>
    );
};

export default TrialBanner;